import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/Frame.vue"),
    children: [
      {
        path: "",
        name: "Index",
        component: () => import("../views/IndexView.vue"),
        meta: {
          rolesAllowed: ["ROLE_ADMIN"],
        },
      },

      {
        path: "director-index",
        name: "DirectorIndex",
        component: () => import("../views/DirectorIndex.vue"),
        meta: {
          isDirector: true,
        },
      },

      {
        path: "grade-index",
        name: "GradeDirectorIndex",
        component: () => import("../views/GradeDirectorIndex.vue"),
        meta: {},
      },

      {
        path: "config",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "scene",
            name: "SceneSetting",
            component: () => import("../views/config/SceneSetting.vue"),
          },
          {
            path: "app-releases",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "AppReleaseList",
                component: () =>
                  import("../views/AppReleases/AppReleaseList.vue"),
              },
              {
                path: "edit",
                name: "AppReleaseEdit",
                component: () =>
                  import("../views/AppReleases/AppReleaseEdit.vue"),
              },
            ],
          },
        ],
        meta: {
          rolesAllowed: ["ROLE_ADMIN"],
        },
      },

      {
        path: "terms",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "TermList",
            component: () => import("../views/terms/TermList.vue"),
          },
          {
            path: "edit",
            name: "TermEdit",
            component: () => import("../views/terms/TermEdit.vue"),
          },
        ],
      },

      {
        path: "login-logs",
        name: "LoginLogList",
        component: () => import("../views/loginLogs/LoginLogList.vue"),
      },

      {
        path: "course-goals",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "CourseGoalList",
            component: () => import("../views/courseGoals/CourseGoalList.vue"),
          },
          {
            path: "edit",
            name: "CourseGoalEdit",
            component: () => import("../views/courseGoals/CourseGoalEdit.vue"),
          },
        ],
      },

      {
        path: "clazzes",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "ClazzList",
            component: () => import("../views/clazzes/ClazzList.vue"),
          },
          {
            path: "edit",
            name: "ClazzEdit",
            component: () => import("../views/clazzes/ClazzEdit.vue"),
          },
        ],
      },

      {
        path: "students",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "StudentList",
            component: () => import("../views/students/StudentList.vue"),
          },
          {
            path: "edit",
            name: "StudentEdit",
            component: () => import("../views/students/StudentEdit.vue"),
          },
          {
            path: "import",
            name: "StudentImport",
            component: () => import("../views/students/StudentImport.vue"),
          },
          {
            path: "change-clazz/:id",
            name: "StudentChangeClazz",
            component: () => import("../views/students/StudentChangeClazz.vue"),
          },
        ],
      },

      {
        path: "guardian-infos",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "edit",
            name: "GuardianInfoEdit",
            component: () =>
              import("../views/guardianInfos/GuardianInfoEdit.vue"),
          },
        ],
      },

      {
        path: "courses",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "CourseList",
            component: () => import("../views/courses/CourseList.vue"),
          },
          {
            path: "edit",
            name: "CourseEdit",
            component: () => import("../views/courses/CourseEdit.vue"),
          },
        ],
      },

      {
        path: "grade-duties",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "GradeDutyList",
            component: () =>
              import("../views/duties/gradeDuties/GradeDutyList.vue"),
          },
          {
            path: "edit",
            name: "GradeDutyEdit",
            component: () =>
              import("../views/duties/gradeDuties/GradeDutyEdit.vue"),
          },
          {
            path: "import",
            name: "GradeDutyImport",
            component: () =>
              import("../views/duties/gradeDuties/GradeDutyImport.vue"),
          },
        ],
      },

      {
        path: "teacher-duties",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "TeacherDutyList",
            component: () =>
              import("../views/duties/teacherDuties/TeacherDutyList.vue"),
          },
          {
            path: "edit",
            name: "TeacherDutyEdit",
            component: () =>
              import("../views/duties/teacherDuties/TeacherDutyEdit.vue"),
          },
          {
            path: "import",
            name: "TeacherDutyImport",
            component: () =>
              import("../views/duties/teacherDuties/TeacherDutyImport.vue"),
          },
          // {
          //   path: "score-list",
          //   name: "TeacherDutyMaxScoreList",
          //   component: () =>
          //     import("../views/duties/teacherDuties/TeacherDutyMaxScoreList.vue"),
          // },
          // {
          //   path: "score-edit/:id",
          //   name: "TeacherDutyMaxScoreEdit",
          //   component: () =>
          //     import("../views/duties/teacherDuties/TeacherDutyMaxScoreEdit.vue"),
          // },
        ],
      },

      {
        path: "safety",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "SafetyFormDemo",
            component: () => import("../views/safety/Demo.vue"),
          },
        ],
      },

      {
        path: "student-groups",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "StudentGroupList",
            component: () =>
              import("../views/studentGroups/StudentGroupList.vue"),
          },
          {
            path: "edit",
            name: "StudentGroupEdit",
            component: () =>
              import("../views/studentGroups/StudentGroupEdit.vue"),
          },
        ],
      },

      {
        path: "users",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "UserList",
            component: () => import("../views/users/UserList.vue"),
          },
          {
            path: "edit",
            name: "UserEdit",
            component: () => import("../views/users/UserEdit.vue"),
          },
          {
            path: "profile",
            name: "Profile",
            component: () => import("../views/users/Profile.vue"),
          },
          {
            path: "change-password",
            name: "ChangePassword",
            component: () => import("../views/users/ChangePassword.vue"),
          },
          {
            path: "import",
            name: "UserImport",
            component: () => import("../views/users/UserImport.vue"),
          },
        ],
      },

      {
        path: "assessment-records",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "AssessmentRecordList",
            component: () =>
              import("../views/assessmentRecords/AssessmentRecordList.vue"),
          },
          {
            path: "president-assessments",
            name: "PresidentAssessmentRecordList",
            component: () =>
              import("../views/assessmentRecords/AssessmentRecordList.vue"),
          },
          {
            path: "choose-clazz",
            name: "ChooseClazz",
            component: () =>
              import("../views/assessmentRecords/ChooseClazz.vue"),
          },
          {
            path: "evaluate",
            name: "EvaluateInOffice",
            component: () => import("../views/assessmentRecords/Evaluate.vue"),
          },
          {
            path: "batch-import",
            name: "BatchImport",
            component: () =>
              import("../views/assessmentRecords/BatchImport.vue"),
          },
        ],
      },

      {
        path: "report-cards",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "ReportCardList",
            component: () => import("../views/reportCards/ReportCardList.vue"),
          },

          {
            path: "student/:studentId/term/:termId/year/:year/month/:month/settle/:settle",
            name: "StudentReportCardView",
            component: () => import("../views/reportCards/StudentView.vue"),
          },

          {
            path: "student/:studentId/term/:termId/last",
            name: "LastStudentReportCardView",
            component: () => import("../views/reportCards/StudentView.vue"),
          },
        ],
      },

      {
        path: "stats",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "assessment-records",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "by-creator",
                name: "StatAssessmentRecordsByCreator",
                component: () =>
                  import("../views/stats/assessmentRecords/ByCreator.vue"),
              },
              {
                path: "by-clazz",
                name: "StatAssessmentRecordsByClazz",
                component: () =>
                  import("../views/stats/assessmentRecords/ByClazz.vue"),
              },
              {
                path: "by-course",
                name: "StatAssessmentRecordsByCourse",
                component: () =>
                  import("../views/stats/assessmentRecords/ByCourse.vue"),
              },
            ],
          },

          {
            path: "assessment-records-gb-grade",
            name: "StatAssessmentRecordsGroupByGrade",
            component: () =>
              import("../views/stats/AssessmentRecordsGroupByGrade.vue"),
          },

          {
            path: "assessment-records-gb-clazz",
            name: "StatAssessmentRecordsGroupByClazz",
            component: () =>
              import("../views/stats/AssessmentRecordsGroupByClazz.vue"),
          },

          {
            path: "assessment-records-gb-student",
            name: "StatAssessmentRecordsGroupByStudent",
            component: () =>
              import("../views/stats/AssessmentRecordsGroupByStudent.vue"),
          },

          // 总结
          {
            path: "summary",
            component: { template: "<router-view/>" },
            children: [
              // 月序号清单

              // 周总结
              {
                path: "week",
                component: { template: "<router-view/>" },
                children: [
                  {
                    path: "",
                    name: "WeekSummaryRecordList",
                    component: () =>
                      import(
                        "../views/stats/summary/WeekSummaryRecordList.vue"
                      ),
                  },
                  {
                    path: ":id",
                    name: "WeekSummaryRecordView",
                    component: () =>
                      import(
                        "../views/stats/summary/WeekSummaryRecordView.vue"
                      ),
                  },

                  // 周序号清单
                  {
                    path: "stat/seq-nos",
                    name: "WeekSummarySeqNoList",
                    component: () => import("../views/weekHonors/WeekList.vue"),
                  },

                  // 汇总
                  {
                    path: "stat/:termId/:weekSeq",
                    name: "WeekHonorStat",
                    component: () =>
                      import("../views/weekHonors/WeekHonorStat.vue"),
                  },
                ],
              },

              // 月总结
              {
                path: "month",
                component: { template: "<router-view/>" },
                children: [
                  {
                    path: "",
                    name: "MonthSummaryRecordList",
                    component: () =>
                      import(
                        "../views/stats/summary/MonthSummaryRecordList.vue"
                      ),
                  },
                  {
                    path: ":id",
                    name: "MonthSummaryRecordView",
                    component: () =>
                      import(
                        "../views/stats/summary/MonthSummaryRecordView.vue"
                      ),
                  },
                  // 周序号清单
                  {
                    path: "stat/monthes",
                    name: "MonthSummaryMonthList",
                    component: () =>
                      import("../views/monthHonors/MonthList.vue"),
                  },

                  // 汇总
                  {
                    path: "stat/:termId/:month",
                    name: "MonthHonorStat",
                    component: () =>
                      import("../views/monthHonors/MonthHonorStat.vue"),
                  },
                ],
              },
            ],
          },

          {
            path: "report-cards-gb-student/:clazzId",
            name: "StatReportCardsGroupByStudent",
            component: () =>
              // import("../views/stats/ReportCardsGroupByStudent.vue"),
              import("../views/stats/current/StudentReportCardList.vue"),
          },

          {
            path: "report-cards-gb-student/last/:clazzId",
            name: "LastStatReportCardsGroupByStudent",
            component: () =>
              import("../views/stats/history/StudentReportCardList.vue"),
          },

          // {
          //   path: "clazz-report-cards",
          //   component: { template: "<router-view/>" },
          //   children: [
          //     {
          //       path: ":grade",
          //       name: "ClazzReportCardList",
          //       component: () =>
          //         import("../views/stats/ClazzReportCardList.vue"),
          //     },
          //   ],
          // },

          {
            path: "grade-report-cards",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "GradeReportCardList",
                component: () =>
                  import("../views/stats/current/GradeReportCardList.vue"),
              },
              {
                path: "last",
                name: "LastGradeReportCardList",
                component: () =>
                  import("../views/stats/history/GradeReportCardList.vue"),
              },
            ],
          },

          {
            path: "clazz-report-cards/:grade",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "ClazzReportCardList",
                component: () =>
                  import("../views/stats/current/ClazzReportCardList.vue"),
              },
              {
                path: "last",
                name: "LastClazzReportCardList",
                component: () =>
                  import("../views/stats/history/ClazzReportCardList.vue"),
              },
            ],
          },

          {
            path: "leave-records",
            name: "LeaveRecordStat",
            meta: {
              rolesAllowed: ["ROLE_DOCTOR", "ROLE_ADMIN"],
            },
            component: () =>
              import("../views/leaveRecords/LeaveRecordStat.vue"),
          },

          {
            path: "stat-continuous-leave-count",
            name: "StatContinuousLeaveCount",
            meta: {
              rolesAllowed: ["ROLE_DOCTOR", "ROLE_ADMIN"],
            },
            component: () =>
              import("../views/leaveRecords/ContinuousLeaveCountStat.vue"),
          },
        ],
      },

      {
        path: "system-config",
        name: "SystemConfig",
        component: () => import("../views/config/Config.vue"),
      },

      {
        path: "config",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "student-columns",
            name: "StudentColumnsConfig",
            component: () => import("../views/config/StudentColumnConfig.vue"),
          },

          {
            path: "assessment-limits",
            name: "AssessmentLimitConfig",
            component: () =>
              import("../views/config/AssessmentLimitConfig.vue"),
          },

          {
            path: "score-progress-bar-type",
            name: "ScoreProgressBarTypeConfig",
            component: () =>
              import("../views/config/ScoreProgressBarTypeConfig.vue"),
          },

          {
            path: "president-assessment-stat-duration-offset",
            name: "PresidentAssessmentStatDurationOffsetConfig",
            component: () =>
              import(
                "../views/config/PresidentsAssessmentStatDurationOffset.vue"
              ),
          },
        ],
      },

      // {
      //   path: "mock",
      //   component: { template: "<router-view/>" },
      //   children: [
      //     {
      //       path: "assessment-record-generate",
      //       name: "GenerateMockAssessmentRecords",
      //       component: () => import("../views/mock/GenAssessmentRecords.vue"),
      //     },
      //   ],
      // },

      {
        path: "/choose-duty",
        name: "ChooseDuty",
        component: () => import("../views/ChooseDuty.vue"),
      },

      {
        path: "/login-duty",
        name: "LoginDuty",
        component: () => import("../views/ChooseDuty.vue"),
      },

      {
        path: "departments",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "DepartmentList",
            component: () =>
              import("../views/docFlow/departments/DepartmentList.vue"),
          },
          {
            path: "edit",
            name: "DepartmentEdit",
            component: () =>
              import("../views/docFlow/departments/DepartmentEdit.vue"),
          },
        ],
      },

      {
        path: "/hospitals",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "HospitalList",
            component: () => import("../views/hospitals/HospitalList.vue"),
          },
          {
            path: "edit",
            name: "HospitalEdit",
            component: () => import("../views/hospitals/HospitalEdit.vue"),
          },
        ],
      },

      {
        path: "user-duties",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "UserDutyList",
            component: () =>
              import("../views/docFlow/userDuties/UserDutyList.vue"),
          },
          {
            path: "edit",
            name: "UserDutyEdit",
            component: () =>
              import("../views/docFlow/userDuties/UserDutyEdit.vue"),
          },
        ],
      },

      {
        path: "student-duties",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "StudentDutyList",
            component: () =>
              import("../views/studentDuties/StudentDutyList.vue"),
          },
          {
            path: "edit",
            name: "StudentDutyEdit",
            component: () =>
              import("../views/studentDuties/StudentDutyEdit.vue"),
          },
        ],
      },

      {
        path: "carousel-datas",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "CarouselDataList",
            component: () =>
              import("../views/carouselDatas/CarouselDataList.vue"),
          },
          {
            path: "edit",
            name: "CarouselDataEdit",
            component: () =>
              import("../views/carouselDatas/CarouselDataEdit.vue"),
          },
        ],
      },

      {
        path: "attendance-records",
        name: "AttendanceRecordList",
        component: () =>
          import("../views/attendanceRecords/AttendanceRecordList.vue"),
      },

      {
        path: "leave-records",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "LeaveRecordList",
            component: () =>
              import("../views/leaveRecords/LeaveRecordList.vue"),
            meta: {
              rolesAllowed: ["ROLE_ADMIN", "ROLE_DOCTOR"],
            },
          },
          {
            path: "stat-detail",
            name: "LeaveRecordStatDetail",
            component: () =>
              import("../views/leaveRecords/LeaveRecordList.vue"),
            meta: {
              rolesAllowed: ["ROLE_ADMIN", "ROLE_DOCTOR"],
            },
          },
          {
            path: "year/:year",
            name: "GradeLeaveRecordList",
            component: () =>
              import("../views/leaveRecords/LeaveRecordList.vue"),
          },
          {
            path: "clazz/:clazzId",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "ClazzLeaveRecordList",
                component: () =>
                  import("../views/leaveRecords/LeaveRecordList.vue"),
              },

              {
                path: "need-replenish",
                name: "NeedReplenishLeaveRecordList",
                component: () =>
                  import("../views/leaveRecords/LeaveRecordList.vue"),
              },
            ],
          },
          {
            path: "edit",
            name: "LeaveRecordEdit",
            component: () =>
              import("../views/leaveRecords/LeaveRecordEdit.vue"),
          },
          {
            path: ":id",
            name: "LeaveRecordView",
            component: () =>
              import("../views/leaveRecords/LeaveRecordView.vue"),
          },
        ],
      },

      {
        path: "/dimension-report/term/:termId/year/:year/month/:month",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "student/:studentId",
            name: "StudentDimensionReport",
            component: () =>
              import("../views/dimensionReports/StudentReport.vue"),
          },
        ],
      },

      {
        path: "/review",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "indicators/grade/:grade/course/:courseId",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "IndicatorList",
                component: () =>
                  import("../views/review/indicators/IndicatorList.vue"),
              },
              {
                path: "edit",
                name: "IndicatorEdit",
                component: () =>
                  import("../views/review/indicators/IndicatorEdit.vue"),
              },
            ],
          },

          {
            path: "exam-papers",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "ExamPaperList",
                component: () =>
                  import("../views/review/examPapers/ExamPaperList.vue"),
              },
              {
                path: "edit",
                name: "ExamPaperEdit",
                component: () =>
                  import("../views/review/examPapers/ExamPaperEdit.vue"),
              },
              {
                path: ":id",
                component: { template: "<router-view/>" },
                children: [
                  {
                    path: "validity-stat",
                    name: "ExamPaperValidityStat",
                    component: () =>
                      import(
                        "../views/review/examPapers/ExamPaperValidityStat.vue"
                      ),
                  },

                  {
                    path: "report",
                    component: { template: "<router-view/>" },
                    children: [
                      {
                        path: "student/:studentId",
                        name: "ReviewStudentReport",
                        component: () =>
                          import("../views/review/reports/StudentReviewReport"),
                      },
                    ],
                  },
                ],
              },
            ],
          },

          {
            path: ":examPaperId/exam-questions",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "ExamQuestionList",
                component: () =>
                  import("../views/review/examQuestions/ExamQuestionList.vue"),
              },
              {
                path: "edit",
                name: "ExamQuestionEdit",
                component: () =>
                  import("../views/review/examQuestions/ExamQuestionEdit.vue"),
              },
            ],
          },

          {
            path: ":examPaperId/exam-records",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "choose-clazz",
                name: "ReviewExamRecordBatchImportChooseClazz",
                component: () =>
                  import("../views/review/examRecords/ChooseClazz.vue"),
              },
              {
                path: ":clazzId",
                component: { template: "<router-view/>" },
                children: [
                  {
                    path: "",
                    name: "ReviewExamRecordView",
                    component: () =>
                      import("../views/review/examRecords/ExamRecordView.vue"),
                  },
                  {
                    path: "import",
                    name: "ReviewExamRecordBatchImport",
                    component: () =>
                      import("../views/review/examRecords/BatchImport.vue"),
                  },
                ],
              },
            ],
          },
        ],
      },

      {
        path: "month-exam",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "course-items",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "CourseItemList",
                component: () =>
                  import("../views/monthExam/courseItems/CourseItemList.vue"),
              },
              {
                path: "edit",
                name: "CourseItemEdit",
                component: () =>
                  import("../views/monthExam/courseItems/CourseItemEdit.vue"),
              },
            ],
          },

          {
            path: "course-item-goals",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "CourseItemGoalList",
                component: () =>
                  import(
                    "../views/monthExam/courseItemGoals/CourseItemGoalList.vue"
                  ),
              },
              {
                path: "edit",
                name: "CourseItemGoalEdit",
                component: () =>
                  import(
                    "../views/monthExam/courseItemGoals/CourseItemGoalEdit.vue"
                  ),
              },
            ],
          },

          {
            path: "batches",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "BatchList",
                component: () =>
                  import("../views/monthExam/batches/BatchList.vue"),
              },
              {
                path: "dashboard",
                name: "BatchDashboard",
                component: () =>
                  import("../views/monthExam/dashboards/SchoolDashboard.vue"),
              },

              // 考试统计列表页
              {
                path: "stats",
                name: "BatchStatIndex",
                component: () =>
                  import("../views/monthExam/batches/BatchList.vue"),
              },

              // 分布统计列表页
              {
                path: "score-batch-list",
                name: "ScoreBatchStat",
                component: () =>
                  import("../views/monthExam/batches/BatchList.vue"),
              },

              // 缺考统计列表页
              {
                path: "make-up-batch-list",
                name: "MakeUpBatchList",
                component: () =>
                  import("../views/monthExam/batches/BatchList.vue"),
              },
              {
                path: "edit",
                name: "BatchEdit",
                component: () =>
                  import("../views/monthExam/batches/BatchEdit.vue"),
              },
              {
                path: ":id",
                component: { template: "<router-view/>" },
                children: [
                  {
                    path: "",
                    name: "BatchView",
                    component: () =>
                      import("../views/monthExam/batches/BatchView.vue"),
                  },
                  {
                    path: "stat/by-grade",
                    name: "BatchStatByGrade",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/ByGrade.vue"
                      ),
                  },
                  {
                    path: "stat/by-clazz/grade-year/:gradeYear",
                    name: "BatchStatByClazz",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/ByClazz.vue"
                      ),
                  },
                  {
                    path: "stat/by-student/clazz/:clazzId",
                    name: "BatchStatByStudent",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/ByStudent.vue"
                      ),
                  },
                  {
                    path: "clazz-student-reports/clazz/:clazzId",
                    name: "ClazzStudentReports",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/ClazzStudentReports.vue"
                      ),
                  },
                  {
                    path: "student-report/batch/:batchId/student/:studentId",
                    name: "StudentReport",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/StudentReport.vue"
                      ),
                  },

                  {
                    path: "stat/by-grade-score",
                    name: "BatchStatByGrade_Score",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/ByGrade_Score.vue"
                      ),
                  },

                  {
                    path: "stat/by-clazz-score/grade-year/:gradeYear",
                    name: "BatchStatByClazz_Score",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/stats/ByClazz_Score.vue"
                      ),
                  },

                  // 待补考清单
                  {
                    path: "make-up-exam-records",
                    name: "MakeUpExamRecordList",
                    component: () =>
                      import(
                        "../views/monthExam/examRecords/MakeUpExamRecordList.vue"
                      ),
                  },
                ],
              },
            ],
          },

          {
            path: "course-item-place-configs",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "",
                name: "CourseItemPlaceConfigList",
                component: () =>
                  import(
                    "../views/monthExam/courseItemPlaceConfigs/CourseItemPlaceConfigList.vue"
                  ),
              },
              {
                path: "edit",
                name: "CourseItemPlaceConfigEdit",
                component: () =>
                  import(
                    "../views/monthExam/courseItemPlaceConfigs/CourseItemPlaceConfigEdit.vue"
                  ),
              },
            ],
          },
        ],
      },
    ],
  },

  // {
  //   path: "/doc-flow",
  //   component: () => import("../views/Frame.vue"),
  //   children: [

  //   ],
  // },

  {
    path: "/login",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/evaluate-in-clazz/:clazzId",
    component: () => import("../views/ClazzFrame.vue"),
    children: [
      {
        path: "",
        name: "EvaluateInClazz",
        component: () => import("../views/assessmentRecords/Evaluate.vue"),
      },
    ],
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/dashboards/Dashboard.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  } else {
    store.dispatch("getProjectName").then(() => {
      document.title = store.state.projectName;
    });
  }

  //获取路由访问权限
  const rolesAllowed = to.meta.rolesAllowed;
  if (rolesAllowed) {
    if (Array.isArray(rolesAllowed)) {
      // 如果权限配置是数组
      const hasRole = rolesAllowed.some((role) =>
        store.getters.isUserInRole(role)
      );
      if (!hasRole) {
        next({
          name: "Login",
        });
        return;
      }
    } else if (typeof rolesAllowed === "string") {
      // 如果权限配置是字符串
      const hasRole = store.getters.isUserInRole(rolesAllowed);
      if (!hasRole) {
        next({
          name: "Login",
        });
        return;
      }
    }
  }

  const isDirector = to.meta.isDirector;
  if (isDirector) {
    if (store.getters.duty && store.getters.duty.director) {
      next();
    } else {
      next({ name: "LoginDuty" });
    }
  }

  if (to.name === "Login") {
    next();
    return;
  } else if (
    to.path.indexOf("/static") === 0 ||
    to.path.indexOf("/@/static") === 0
  ) {
    next();
  } else if (
    to.name === "SceneSetting" ||
    to.name === "ChooseDuty" ||
    to.name === "LoginDuty"
  ) {
    next();
  } else if (to.name === "EvaluateInClazz") {
    next();
  } else {
    if (store.state.sceneSetting) {
      next({
        name: "ChooseDuty",
      });
    }
    next();
  }
});

export default router;
